// One-time localStorage migration: cryptolens_* → mycryptoplanner_*
// Existing users keep their portfolios, plans, theme preference, etc. without re-entry.
// Runs once on app boot; the completion flag prevents repeat work.

const PREFIX_OLD = 'cryptolens_';
const PREFIX_NEW = 'mycryptoplanner_';
const FLAG_KEY   = 'mycryptoplanner_migration_v1_complete';

export function migrateLegacyStorage(): void {
  try {
    if (typeof localStorage === 'undefined') return;
    if (localStorage.getItem(FLAG_KEY)) return;

    const legacyKeys: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(PREFIX_OLD)) legacyKeys.push(key);
    }

    for (const oldKey of legacyKeys) {
      const newKey = PREFIX_NEW + oldKey.slice(PREFIX_OLD.length);
      // Only copy when the new key is empty — never clobber a fresh value
      if (localStorage.getItem(newKey) === null) {
        const value = localStorage.getItem(oldKey);
        if (value !== null) localStorage.setItem(newKey, value);
      }
      localStorage.removeItem(oldKey);
    }

    localStorage.setItem(FLAG_KEY, '1');
  } catch {
    // Private browsing / quota exceeded — silently skip
  }
}
